import React from 'react';
import { BookOpen, ArrowLeftRight, Users, ShoppingBag, User as UserIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type TabKey = 'album' | 'trocas' | 'amigos' | 'parceiros' | 'perfil';

interface Props {
  active: TabKey;
  onChange: (key: TabKey) => void;
  badge?: Partial<Record<TabKey, number>>;
}

const TABS: { key: TabKey; label: string; icon: LucideIcon }[] = [
  { key: 'album', label: 'Álbum', icon: BookOpen },
  { key: 'trocas', label: 'Trocas', icon: ArrowLeftRight },
  { key: 'amigos', label: 'Amigos', icon: Users },
  { key: 'parceiros', label: 'Parceiros', icon: ShoppingBag },
  { key: 'perfil', label: 'Perfil', icon: UserIcon },
];

export function Tabs({ active, onChange, badge }: Props) {
  return (
    <nav className="hidden md:block bg-white border-b border-ink-300 sticky top-[57px] z-40">
      <div className="max-w-shell mx-auto px-6 flex gap-2">
        {TABS.map((t) => {
          const Icon = t.icon;
          const isActive = t.key === active;
          const count = badge?.[t.key] ?? 0;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => onChange(t.key)}
              className={[
                'relative inline-flex items-center gap-2 px-4 py-3.5 font-body text-small font-semibold',
                'border-b-[2.5px] -mb-px transition-colors duration-fast btn-focus',
                isActive
                  ? 'text-green-900 border-green-700'
                  : 'text-ink-500 border-transparent hover:text-ink-700',
              ].join(' ')}
            >
              <span className="relative inline-flex">
                <Icon size={16} strokeWidth={isActive ? 2.5 : 2} />
                {count > 0 && (
                  <span className="absolute -top-1.5 -right-2 min-w-[16px] h-[16px] rounded-full bg-green-700 text-white text-[9px] font-display font-bold inline-flex items-center justify-center px-1">
                    {count > 9 ? '9+' : count}
                  </span>
                )}
              </span>
              {t.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
